/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { PublicApiRequestAudit } from "./PublicApiRequestAudit";
import {
  PublicApiRequestAuditFromJSON,
  PublicApiRequestAuditFromJSONTyped,
  PublicApiRequestAuditToJSON,
  PublicApiRequestAuditToJSONTyped,
} from "./PublicApiRequestAudit";

/**
 * One page of the request log, plus what the panel's filters and description need: every endpoint the public API serves (not only those with a row, so a filter never depends on what the page holds) and how long rows are kept.
 * @export
 * @interface HubblePublicApiRequestPage
 */
export interface HubblePublicApiRequestPage {
  /**
   *
   * @type {Array<PublicApiRequestAudit>}
   * @memberof HubblePublicApiRequestPage
   */
  requests: Array<PublicApiRequestAudit>;
  /**
   *
   * @type {number}
   * @memberof HubblePublicApiRequestPage
   */
  totalCount: number;
  /**
   *
   * @type {number}
   * @memberof HubblePublicApiRequestPage
   */
  page: number;
  /**
   *
   * @type {number}
   * @memberof HubblePublicApiRequestPage
   */
  pageSize: number;
  /**
   *
   * @type {Array<string>}
   * @memberof HubblePublicApiRequestPage
   */
  endpoints: Array<string>;
  /**
   *
   * @type {number}
   * @memberof HubblePublicApiRequestPage
   */
  retentionMonths: number;
  /**
   *
   * @type {number}
   * @memberof HubblePublicApiRequestPage
   */
  bookedShipmentRetentionMonths: number;
}

/**
 * Check if a given object implements the HubblePublicApiRequestPage interface.
 */
export function instanceOfHubblePublicApiRequestPage(
  value: object,
): value is HubblePublicApiRequestPage {
  if (!("requests" in value) || value["requests"] === undefined) return false;
  if (!("totalCount" in value) || value["totalCount"] === undefined)
    return false;
  if (!("page" in value) || value["page"] === undefined) return false;
  if (!("pageSize" in value) || value["pageSize"] === undefined) return false;
  if (!("endpoints" in value) || value["endpoints"] === undefined) return false;
  if (!("retentionMonths" in value) || value["retentionMonths"] === undefined)
    return false;
  if (
    !("bookedShipmentRetentionMonths" in value) ||
    value["bookedShipmentRetentionMonths"] === undefined
  )
    return false;
  return true;
}

export function HubblePublicApiRequestPageFromJSON(
  json: any,
): HubblePublicApiRequestPage {
  return HubblePublicApiRequestPageFromJSONTyped(json, false);
}

export function HubblePublicApiRequestPageFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): HubblePublicApiRequestPage {
  if (json == null) {
    return json;
  }
  return {
    requests: (json["requests"] as Array<any>).map(
      PublicApiRequestAuditFromJSON,
    ),
    totalCount: json["totalCount"],
    page: json["page"],
    pageSize: json["pageSize"],
    endpoints: json["endpoints"],
    retentionMonths: json["retentionMonths"],
    bookedShipmentRetentionMonths: json["bookedShipmentRetentionMonths"],
  };
}

export function HubblePublicApiRequestPageToJSON(
  json: any,
): HubblePublicApiRequestPage {
  return HubblePublicApiRequestPageToJSONTyped(json, false);
}

export function HubblePublicApiRequestPageToJSONTyped(
  value?: HubblePublicApiRequestPage | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    requests: (value["requests"] as Array<any>).map(
      PublicApiRequestAuditToJSON,
    ),
    totalCount: value["totalCount"],
    page: value["page"],
    pageSize: value["pageSize"],
    endpoints: value["endpoints"],
    retentionMonths: value["retentionMonths"],
    bookedShipmentRetentionMonths: value["bookedShipmentRetentionMonths"],
  };
}
